<template>
    <div class="update-related-protocols-page" v-if="isShow">
        <div class="update-related-protocols-content-mask dialog-mask"></div>
        <div class="update-related-protocols-content mask-content">
            <span class="close-icon" @click="close"></span>
            <div class="update-title">协议更新</div>
            <div class="update-desc">
                <p>尊敬的用户：</p>
                因乐速运营主体变更及服务域名升级，我们更新了
                <a class="a1" v-show="showUserAgreement" target="_blank" :href="userAgreement">《用户注册服务协议》</a
                >、
                <a class="a1" v-show="showPrivacyPolicy" target="_blank" :href="privacyPolicy">《用户隐私政策》</a>
                您的账号权益不受任何影响。 为保障您的正常使用，请点击下方按钮确认同意更新后的条款。
            </div>
            <div class="op-wrap">
                <span class="confirm" @click="confirm">同意并继续</span>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { agreeUserAgreement } from '@/http/api/user.js'

export default {
    name: 'UpdateRelatedProtocols',
    data() {
        return {
            isShow: false,
            showUserAgreement: false,
            showPrivacyPolicy: false
        }
    },
    computed: {
        userAgreement: function () {
            return this.$Utils.appendParametersToUrl(this.$store.state.userAgreement, {
                type: 'from-update-dialog'
            })
        },
        privacyPolicy: function () {
            return this.$Utils.appendParametersToUrl(this.$store.state.privacyPolicy, {
                type: 'from-update-dialog'
            })
        }
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.request = false
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('update-related-protocols-page')
                })
            }
        }
    },
    methods: {
        show(option) {
            this.isShow = true
            if (option instanceof Object) {
                this.showUserAgreement = option.showUserAgreement
                this.showPrivacyPolicy = option.showPrivacyPolicy
            }
        },
        async close() {
            this.isShow = false
            this.$EventBus.$emit('quit-click')
            await this.$Utils.sleep(500)
            Vue.prototype.$Login.show()
        },
        confirm() {
            if (this.request) {
                return false
            }
            this.request = true
            agreeUserAgreement()
                .then((res) => {
                    this.request = false
                    if (res.code === 200) {
                        this.isShow = false
                    } else {
                        this.$Toast.show(res.msg || '操作失败，请稍后再试')
                    }
                })
                .catch(() => {
                    this.request = false
                })
        }
    }
}
</script>
<style lang="less" scoped>
.update-related-protocols-page {
    .update-related-protocols-content {
        width: 540px;
        height: 343px;
        background: @bg-color-dialog;
        padding-top: 60px;

        .update-title {
            color: #ffffff;
            text-align: center;
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            margin-bottom: 20px;
        }

        .update-desc {
            margin: 0 auto;
            width: 450px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;

            .a1 {
                cursor: pointer;
                text-decoration: none;
                color: #e8ef00;
            }
        }

        .op-wrap {
            position: absolute;
            width: 100%;
            bottom: 60px;
            left: 50%;
            padding: 0 55px;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;

            &.two-btn {
                justify-content: space-between;
            }

            > span {
                .button-linear();
                width: 150px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                cursor: pointer;
                color: #000000;
            }
        }
    }
}
</style>
